import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4895_4354)">
      <path
        d="M14.6075 1.3928C14.1953 0.981187 13.6365 0.75 13.054 0.75C12.4714 0.75 11.9127 0.981187 11.5004 1.3928L1.63835 11.2549C1.35593 11.5357 1.132 11.8698 0.979521 12.2377C0.827039 12.6056 0.749031 13.0001 0.750009 13.3984V14.6433C0.750009 14.8041 0.813895 14.9584 0.927612 15.0721C1.04133 15.1858 1.19556 15.2497 1.35638 15.2497H2.60127C2.99952 15.2508 3.39403 15.1729 3.76197 15.0205C4.12991 14.8682 4.46397 14.6443 4.74481 14.362L14.6075 4.49926C15.0189 4.08704 15.25 3.52843 15.25 2.94603C15.25 2.36362 15.0189 1.80501 14.6075 1.3928ZM3.8874 13.5045C3.5454 13.8443 3.08332 14.0355 2.60127 14.0369H1.96276V13.3984C1.96215 13.1595 2.00894 12.9227 2.10043 12.702C2.19192 12.4812 2.32629 12.2808 2.49576 12.1123L9.98026 4.62781L11.3749 6.02247L3.8874 13.5045ZM13.7495 3.64184L12.2299 5.16203L10.8352 3.77039L12.3554 2.25021C12.447 2.15884 12.5557 2.08639 12.6753 2.03702C12.7948 1.98764 12.9229 1.9623 13.0523 1.96244C13.1817 1.96258 13.3098 1.9882 13.4292 2.03784C13.5487 2.08747 13.6572 2.16015 13.7486 2.25173C13.84 2.3433 13.9124 2.45198 13.9618 2.57155C14.0111 2.69112 14.0365 2.81925 14.0363 2.94861C14.0362 3.07798 14.0106 3.20605 13.961 3.32552C13.9113 3.44498 13.8386 3.5535 13.7471 3.64487L13.7495 3.64184Z"
        fill="#151718"
      />
    </g>
    <defs>
      <clipPath id="clip0_4895_4354">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const PencilIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default PencilIcon;
